module.exports = __webpack_public_path__ + "static/media/astron-page.905ddc44.jpg";